import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import ContactForm from './form/form.component'
import { Message } from '../../../components'

import {
  createContact,
  updateContact,
  updateContactStrategy,
  createChangeRequest,
  resetForm,
  createToast,
  searchInstitution,
  searchInstitutions,
  searchFunds,
  clearSuggestions,
  openModal,
  closeModal,
  CREATE_CHANGE_REQUEST_SUCCESS,
  CREATE_CHANGE_REQUEST_FAILURE,
  statusType
} from '../../../actions'

import { MESSAGE } from '../../../utils'

import './edit.container.scss'
import {  } from '../../../actions/changeRequest/changeRequest.actions'

/**
 * Error Message Modal
 * @param onClose
 * @returns {*}
 * @constructor
 */
const ErrorModal = ({ onClose }) => {
  return (
    <Message
      visible
      type='error'
      title='Error'
      message={MESSAGE.ERROR}
      onClose={onClose}
      buttons={[{
        theme: 'spice',
        label: 'close',
        onClick: onClose
      }]} />
  )
}

/**
 * Contact Form
 */
class ContactFormContainer extends Component {
  /**
   * ComponentWillUnmount
   */
  componentWillUnmount () {
    this.props.resetForm()
  }

  /**
   * Map data to form fields
   * Transforms contact from api to form values when editing
   * @param data
   * @param strategy
   * @returns {*}
   */
  mapToFieldValues = (data, strategy) => {
    if (!data) {
      return {}
    }

    return {
      id: data._id,
      source: !data._id ? 'q4' : data.source,
      status: data.status,
      salutation: data.salutation,
      suffixProf: data.suffix_prof,
      fullName: data.full_name,
      firstName: data.first_name,
      lastName: data.last_name,
      nickName: data.nickname,
      email: data.email,
      directPhone: data.direct_phone,
      phoneExtension: data.phone_extension,
      mobile: data.mobile,
      linkedIn: data.linkedin_url,
      website1: data.company_website1,
      website2: data.company_website2,
      fca: data.fca_url,
      sec: data.sec_url,
      finra: data.finra_url,
      bio: (data.bio || '').replace(/\\r|\\n/g, '\n'),
      title: data.title,
      jobs: data.jobs,
      managedFunds: data.managed_funds,
      gdpr: data.gdpr,
      strategy
    }
  }

  /**
   * On Close
   */
  onClose = () => {
    const { onClose, resetForm } = this.props
    onClose && onClose()
    resetForm()
  }

  /**
   * On Save Change Request
   * @param values - form values
   */
  onSaveChangeRequest = (values) => {
    const { profile, createChangeRequest, updateContactStrategy} = this.props
    const contactId = values?.id || null
    const change_type = contactId ? "update" : "create"
    createChangeRequest({ values, profile, change_type })
      .then((data) => {
        const success = CREATE_CHANGE_REQUEST_SUCCESS === data.type
        const failure = CREATE_CHANGE_REQUEST_FAILURE === data.type 

        const id = contactId ||data?.payload?._id
        const strategy = values.strategy || []

        strategy.map((strategy) => {
          strategy._contact = id
          return strategy
        })

        success && updateContactStrategy(id, strategy).then(() => this.onSaveChangeRequestSuccess())
        failure && this.onFailure()
      })
  }
  
  /**
   * On Save Change Request Success
   * Create toast and remove modal component
   * @param values - form values
  */
  onSaveChangeRequestSuccess = (values) => {
    const { createToast, onSaveSuccess } = this.props
    this.onClose()
    onSaveSuccess && onSaveSuccess()
    createToast({ text: 'Change request created successfully.' })
  }

   /**
   * On Request Failure display error
   */
  onFailure () {
    const { openModal } = this.props
    openModal({
      component: ErrorModal
    })
  }

  /**
   * Render
   * @return {XML}
   */
  render () {
    const {
      loading, contact, strategy, openModal, closeModal,
      searchInstitution, searchInstitutions, institutionLoading, institutions,
      searchFunds, fundLoading, funds, clearSuggestions
    } = this.props

    return (
      <ContactForm
        visible
        loading={loading}
        values={this.mapToFieldValues(contact, strategy)}
        searchInstitution={searchInstitution}
        searchInstitutions={searchInstitutions}
        institutionLoading={institutionLoading}
        institutions={institutions}
        searchFunds={searchFunds}
        fundLoading={fundLoading}
        funds={funds}
        clearSuggestions={clearSuggestions}
        onClose={this.onClose}
        onSaveChangeRequest={this.onSaveChangeRequest.bind(this)}
        openModal={openModal}
        closeModal={closeModal} />
    )
  }
}

ContactFormContainer.propTypes = {
  profile: PropTypes.object,
  createToast: PropTypes.func,
  createChangeRequest: PropTypes.func,
  updateContactStrategy: PropTypes.func,
  contact: PropTypes.object,
  strategy: PropTypes.array,
  onClose: PropTypes.func,
  onSaveSuccess: PropTypes.func
}

ContactFormContainer.defaultProps = {}

const mapStateToProps = (state) => {
  return {
    profile: state.profile.data,
    loading: (state.contact.form.status === statusType.IN_PROGRESS) || (state.contact.strategy.status === statusType.IN_PROGRESS),
    institutionLoading: state.contact.institution.status === statusType.IN_PROGRESS,
    institutions: state.contact.institution.suggestions,
    fundLoading: state.contact.fund.status === statusType.IN_PROGRESS,
    funds: state.contact.fund.suggestions
  }
}

const mapDispatchToProps = (dispatch) => ({
  createContact: bindActionCreators(createContact, dispatch),
  updateContact: bindActionCreators(updateContact, dispatch),
  updateContactStrategy: bindActionCreators(updateContactStrategy, dispatch),
  searchInstitution: bindActionCreators(searchInstitution, dispatch),
  searchInstitutions: bindActionCreators(searchInstitutions, dispatch),
  searchFunds: bindActionCreators(searchFunds, dispatch),
  clearSuggestions: bindActionCreators(clearSuggestions, dispatch),
  createToast: bindActionCreators(createToast, dispatch),
  resetForm: bindActionCreators(resetForm, dispatch),
  openModal: bindActionCreators(openModal, dispatch),
  closeModal: bindActionCreators(closeModal, dispatch),
  createChangeRequest: bindActionCreators(createChangeRequest, dispatch)
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContactFormContainer))
